import { useState, useEffect, useContext } from 'react'
import { useQuery } from 'react-query'
import { NavLink, useLocation, Link } from 'react-router-dom'
import { Calendar, ChevronDown, X, FileText, Dribbble, Map, Trello, Server, Database } from 'react-feather'
import { Row, Col, Modal, ModalBody, ModalHeader, Card, CardHeader, CardTitle, Collapse, CardBody, Label, FormGroup } from 'reactstrap'
import { FilterScreenStates } from '@src/utility/context/FilterScreenContext'
import { getOrgDetails } from '@src/api/generic'
import { getOrgs } from '@src/api/admin'
import { setGlobalOrg, getGlobalOrg, isSpAdmin, isOrgAdmin, isVenueAdmin, isMarker, isFinAdmin, selectStyles } from '@utils'
import useAuthStatus from '@hooks/useAuthStatus'
import useEmbed from '@hooks/useEmbed'
import Select from 'react-select'
import themeConfig from '@configs/themeConfig'
import classnames from 'classnames'

const Navbar = () => {
  const location = useLocation()
  const { loggedIn, checkLogin } = useAuthStatus()
  const { isEmbed } = useEmbed()
  const { setResults, setSport, setSportBadge, setDistance, setDate } = useContext(FilterScreenStates)
  const [active, setActive] = useState('play')
  const [showInfo, setShowInfo] = useState(false)
  const [org, setOrg] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const toggleSidebar = () => setSidebarOpen((prevState) => !prevState)
  const [menuData, setMenuData] = useState([])
  const [openMenu, setOpenMenu] = useState(active)
  const [orgs, setOrgs] = useState([])
  const [orgId, setOrgId] = useState(getGlobalOrg())
  if (isEmbed) return null

  const toggleMenu = id => setOpenMenu(id === openMenu ? null : id)

  const forPlay = () => (org === null ? true : org.plan.module !== 'LEARN')
  const forLearn = () => (org === null ? true : org.plan.module !== 'PLAY')

  const { data: oData } = useQuery(['orgs'], () => getOrgs(), { enabled: loggedIn && !checkLogin && isSpAdmin() === true })
  useEffect(() => { if (oData && oData.data) setOrgs(oData.data.map(v => ({ label: v.name, value: v.id }))) }, [oData])
  useEffect(() => { if (orgId && orgId !== getGlobalOrg()) setGlobalOrg(orgId) }, [orgId])
  useEffect(() => { if (getGlobalOrg() > 0 && orgId !== getGlobalOrg()) setOrgId(getGlobalOrg()) }, [getGlobalOrg()])

  useEffect(() => {
    if (org !== null || isSpAdmin()) {
      const mData = []
      if (isSpAdmin() || (forPlay() && (isOrgAdmin() || isVenueAdmin() || isMarker()))) mData.push({
        title: 'Booking Mgmt',
        icon: <Calendar size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/booking-management' state={{ adminTab: '1' }}>Bookings</Link>
          <Link className='font-medium-2 pl-50' to='/admin/booking-management' state={{ adminTab: '4' }}>Slots</Link>
          {org?.familyBook && (isOrgAdmin() || isSpAdmin()) && <Link className='font-medium-2 pl-50' to='/admin/booking-management' state={{ adminTab: '5' }}>Custom Attributes</Link>}
        </div>)
      })
      if (isSpAdmin() || (forLearn() && (isOrgAdmin() || isVenueAdmin()))) mData.push({
        title: 'Coaching Mgmt',
        icon: <Dribbble size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/coaching-management' state={{ adminTab: '1' }}>Programs</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/coaching-management' state={{ adminTab: '2' }}>Batches</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/coaching-management' state={{ adminTab: '3' }}>Enrolments</Link>
          <Link className='font-medium-2 pl-50' to='/admin/coaching-management' state={{ adminTab: '4' }}>Custom Attributes</Link>
          {org?.orgMetric !== 'NONE' && <Link className='font-medium-2 mt-25 pl-50' to='/admin/coaching-management' state={{ adminTab: '5' }}>Manage Metrics</Link>}
          {org?.orgMetric !== 'NONE' && <Link className='font-medium-2 mt-25 pl-50' to='/admin/coaching-management' state={{ adminTab: '6' }}>View Metrics Data</Link>}
        </div>)
      })
      if (isSpAdmin() || isOrgAdmin() || isVenueAdmin()) mData.push({
        title: 'Member Mgmt',
        icon: <Database size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          {(isSpAdmin() || isOrgAdmin()) && <Link className='font-medium-2 mb-25 pl-50' to='/admin/member-management' state={{ adminTab: '1' }}>Members</Link>}
          {(isSpAdmin() || isOrgAdmin()) && <Link className='font-medium-2 mb-25 pl-50' to='/admin/member-management' state={{ adminTab: '2' }}>Non-Members</Link>}
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/member-management' state={{ adminTab: '3' }}>Subscriptions</Link>
        </div>)
      })
      if (isSpAdmin() || isOrgAdmin() || isVenueAdmin() || isFinAdmin()) mData.push({
        title: 'Reports',
        icon: <FileText size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 pl-50' to='/admin/reports' state={{ adminTab: '1' }}>All Reports</Link>
          {isSpAdmin() && <Link className='font-medium-2 mt-1 pl-50' to='/admin/reports' state={{ adminTab: '2' }}>Booking Report</Link>}
        </div>)
      })
      if (isSpAdmin() || (forPlay() && (isOrgAdmin() || isVenueAdmin()))) mData.push({
        title: 'Venue Mgmt',
        icon: <Map size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/venue-management' state={{ adminTab: '1' }}>Fields</Link>
          <Link className='font-medium-2 pl-50' to='/admin/venue-management' state={{ adminTab: '2' }}>Open-Hours</Link>
        </div>)
      })
      if (isSpAdmin() || isOrgAdmin()) mData.push({
        title: 'Org Mgmt',
        icon: <Trello size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/org-management' state={{ adminTab: '1' }}>Dashboard</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/org-management' state={{ adminTab: '3' }}>Org Users</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/org-management' state={{ adminTab: '4' }}>Venues</Link>
          <Link className='font-medium-2 pl-50' to='/admin/org-management' state={{ adminTab: '5' }}>Discounts</Link>
        </div>)
      })
      if (isSpAdmin()) mData.push({
        title: 'Shareplay Mgmt',
        icon: <Server size={18} />,
        content: (<div className='d-flex flex-column' onClick={toggleSidebar}>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '6' }}>Orgs</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '1' }}>Bill Plans</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '2' }}>Sports</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '9' }}>Categories</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '4' }}>Settlements</Link>
          <Link className='font-medium-2 mb-25 pl-50' to='/admin/shareplay-management' state={{ adminTab: '5' }}>Reports</Link>
          <Link className='font-medium-2 pl-50' to='/admin/shareplay-management' state={{ adminTab: '7' }}>Metrics</Link>
        </div>)
      })
      setMenuData(mData)
    }
  }, [org])

  const { data: odData } = useQuery(['orgDetails', orgId], () => getOrgDetails(orgId), { enabled: loggedIn && !checkLogin && !!orgId })
  useEffect(() => { if (odData && odData.data) setOrg(odData.data) }, [odData])

  useEffect(() => {
    const loc = location.pathname.split('/')[1]
    if (['play', 'venue'].includes(loc)) setActive('play')
    else if (['learn', 'program', 'enroll', 'coach', 'batches', 'batch', 'attendance', 'batchinfo'].includes(loc)) setActive('coach')
    else if (['admin'].includes(loc)) setActive('admin')
    else setActive('none')
    setShowInfo(false)
  }, [location])

  useEffect(() => { if (showInfo) setTimeout(() => setShowInfo(false), 2500) }, [showInfo])

  const handleInfo = () => { if (active === 'none') setShowInfo(!showInfo) }

  const handlePlayClick = () => {
    if (location.pathname === '/play') {
      setResults([])
      setSport('')
      setSportBadge([])
      setDistance(10000)
      setDate(new Date())
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  const handleOrg = id => {
    setOrgId(id)
    setTimeout(() => window.location.reload(), 500)
  }

  return (
    <Row className='mobile-navbar mx-0 py-50 d-flex justify-content-center'>
      <div className='menu-box d-flex flex-row justify-content-between align-items-center flex-gap-2'>
        <Col className='p-50'>
          <NavLink to='/home' onClick={() => handlePlayClick()} className='d-flex flex-column justify-content-center align-items-center'>
            <img src={themeConfig.app.appLogoImage} alt='Shareplay' className='navbar-logo' />
          </NavLink>
        </Col>
        <Col className='p-50'>
          <NavLink to='/play' onClick={() => handlePlayClick()} className='d-flex flex-column justify-content-center align-items-center'>
            <img src={active === 'play' ? themeConfig.app.playOnImage : themeConfig.app.playOffImage} alt='Play' className='navbar-logo' />
          </NavLink>
        </Col>
        <Col className='p-50'>
          <NavLink to='/learn' className='d-flex flex-column justify-content-center align-items-center'>
            <img src={active === 'coach' ? themeConfig.app.coachOnImage : themeConfig.app.coachOffImage} alt='Learn' className='navbar-logo' />
          </NavLink>
        </Col>
        {(isSpAdmin() || isOrgAdmin() || isVenueAdmin() || isMarker() || isFinAdmin()) &&
          <Col className='d-flex flex-column justify-content-center align-items-center p-50 cursor-pointer' onClick={toggleSidebar}>
            <img src={active === 'admin' ? themeConfig.app.adminOnImage : themeConfig.app.adminOffImage} alt='Admin' className='navbar-logo' />
          </Col>}
      </div>
      <Modal isOpen={sidebarOpen} toggle={toggleSidebar} className='sidebar-lg' contentClassName='p-0' modalClassName='modal-slide-in event-sidebar'>
        <ModalHeader className='mb-0' toggle={toggleSidebar} close={<X className='cursor-pointer' size={15} onClick={toggleSidebar} />} tag='div' />
        <ModalBody>
          <img src={themeConfig.app.adminOnImage} alt='Admin' className='min-w-85px' />
          {isSpAdmin() && <FormGroup>
            <Label for='org'>Org:</Label>
            <Select
              isMulti={false}
              searchable
              id='org'
              name='org'
              options={orgs}
              value={orgs.filter(o => o.value === orgId)}
              styles={selectStyles()}
              menuPortalTarget={document.modal}
              onChange={d => handleOrg(d.value)}
            />
          </FormGroup>}
          <div className='collapse-icon collapse-border'>
            {menuData.map((m, i) => <Card className={classnames('app-collapse', { open: openMenu === i })} key={i}>
              <CardHeader className={classnames('align-items-center', { collapsed: openMenu !== i })} onClick={() => toggleMenu(i)}>
                <CardTitle className='collapse-title text-dark'>{m.icon}<span className='ml-50'>{m.title}</span></CardTitle>
                <ChevronDown size={14} />
              </CardHeader>
              <Collapse isOpen={openMenu === i}>
                <CardBody>{m.content}</CardBody>
              </Collapse>
            </Card>)}
          </div>
        </ModalBody>
      </Modal>
    </Row>
  )
}

export default Navbar